'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// ./~/es6-symbol/index.js
// module id = 753
// module chunks = 0